import { cn } from "@veritrellis/ui";
import type { ReactNode } from "react";

type FormFieldWidth = "md" | "lg" | "xl" | "full";

const widthClasses: Record<FormFieldWidth, string> = {
  md: "max-w-md",
  lg: "max-w-lg",
  xl: "max-w-xl",
  full: "w-full max-w-none"
};

type FormFieldProps = {
  children: ReactNode;
  className?: string;
  width?: FormFieldWidth;
};

const widthAdminClass: Record<FormFieldWidth, string> = {
  md: "admin-form-field",
  lg: "admin-form-field admin-form-field-wide",
  xl: "admin-form-field admin-form-field-wide",
  full: "admin-form-field admin-form-field-full"
};

/** Label + control stack with sensible max width (avoids full-viewport inputs). */
export const FormField = ({ children, className, width = "md" }: FormFieldProps) => (
  <div className={cn(widthAdminClass[width], widthClasses[width], className)}>{children}</div>
);
